import React, { Component } from 'react'
import history from '../common/history.js'
import { inject, observer } from 'mobx-react'

@inject('filtersStore')
@observer
class ProductLabel extends Component {
  toggleActive = (e) => {
    if (this.props.onToggle) this.props.onToggle(e)
    const { filtersStore, removeNonInstrumentTags, homeOnFiltersClear } = this.props;
    if (removeNonInstrumentTags) filtersStore.removeNonInstrumentTags();
    this.changeTags()
    let params = filtersStore.toParams()

    const path = (filtersStore.isBlank() && homeOnFiltersClear) ? '/' : window.location.pathname
    history.push(`${path}?${params}`)
  }

  get isActive() {
    return !!this.props.filtersStore.tags.find((tag) => { return tag === this.props.uuid })
  }

  changeTags() {
    const { filtersStore } = this.props

    filtersStore.page = 1
    filtersStore.changeTags(this.props.uuid)

    let path = window.location.pathname
    if (path.match(/^\/search|^\/instrument|^\/genre|^\/label/)) {
      let params = filtersStore.toParams()
      const blank = filtersStore.isBlank()
      if (blank) { path = '/' }
      if (!filtersStore.isCustomUrl()) { path = '/search' }
      history.push(`${path}?${params}`);
    }
  }

  render() {
    const { children, yellowButton, number } = this.props
    return (
      <button
        type='button'
        onClick={this.toggleActive}
        className={`flex px-2 py-0.5 bg-gray-11 cursor-pointer rounded ${this.isActive ? 'bg-orange-1' : 'xl:brightness-125'}`}
      >
        <span className={`${this.isActive? 'text-gray-16' : 'text-gray-3'}`}>{children}</span>
        {
          this.props.number && (
            <span className={`font-bold ml-1.5 ${this.isActive? 'text-gray-16' : ''}`}>{number}</span>
          )
        }
      </button>
    )
  }
}

export default ProductLabel
